import { Component, Injector, Input } from '@angular/core';
import { MakeProvider } from '../AbstractValueAccessor';
import { TranslateService } from '@ngx-translate/core';
import { BsNgInputBaseComponent } from '../BsNgInputTextBaseComponent';
import { NgControl } from '@angular/forms';
import { ValidationBaseOptions } from '../../../validators/ValidationBaseOptions';

@Component({
  selector: 'bs-ng-date',
  templateUrl: './bs-ng-date.component.html',
  providers: [MakeProvider(BsNgDateComponent)],
})
export class BsNgDateComponent extends BsNgInputBaseComponent {
  @Input() type?: 'date' | 'time' | 'datetime-local' = 'date';

  private readonly _defaultDateMin = '1900-01-01';
  private _min: string;
  @Input()
  public set min(value: string) {
    this._min = value;
  }
  public get min(): string {
    if (this.type == 'date') {
      return this._min || this._defaultDateMin;
    }

    return this._min;
  }

  constructor(translate: TranslateService, injector: Injector) {
    super(translate, injector);
  }

  ngOnInit() {
    if (this.key !== '') {
      this.getTranslations();
    }
    this.ngControl = this.inj.get(NgControl);
  }

  get hasErrors(): boolean {
    if (this.ngControl.control.touched) {
      return this.ngControl.errors && true;
    }

    return false;
  }
}
